import { required } from 'vuelidate/lib/validators'

const isValidEmail = (value) => {
    // eslint-disable-next-line no-control-regex
    const emailRegExp = /(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    return !!emailRegExp.test(value)
}

export default {
    validations: {
        name: {
            required,
        },
        email: {
            required,
            isValidEmail
        },
        subjectAux: {
            required,
        },
        messageAux: {
            required
        },
    },

    computed: {
        nameErrors () {
            let errors = ''

            if (!this.$v.name.$dirty) {
                return errors
            }

            if (!this.$v.name.required) errors = errors.concat(this.$t('validations.name_is_required'))

            return errors
        },

        emailErrors () {
            let errors = ''

            if (!this.$v.email.$dirty) {
                return errors
            }

            if (!this.$v.email.required) errors = errors.concat(this.$t('validations.email_is_required'))

            if (!this.$v.email.isValidEmail) errors = errors.concat(this.$t('validations.email_has_invalid_format'))

            return errors
        },

        subjectErrors () {
            let errors = ''

            if (!this.$v.subjectAux.$dirty) {
                return errors
            }

            if (!this.$v.subjectAux.required) errors = errors.concat(this.$t('validations.subject_is_required'))

            return errors
        },

        messageErrors () {
            let errors = ''

            if (!this.$v.messageAux.$dirty) {
                return errors
            }

            if (!this.$v.messageAux.required) errors = errors.concat(this.$t('validations.message_is_required'))

            return errors
        },
    }
}